<template>
  <div class="chart">
    <svg :width="width + 'px'" :height="height">
      <path
        :d="trendline_data"
        class="line"
        fill="none"
        stroke-width="1"
        stroke="#999"
      />
      <path
        :d="line_data"
        class="line"
        fill="none"
        stroke-width="2"
        stroke="black"
      />
    </svg>
    <div id="co2val" class="textoverlay">CO<sub>2</sub>: {{ co2val }}</div>
  </div>
</template>

<script>
import * as d3 from 'd3'

export default {

  name: 'Co2Chart',
  props: {
    date: Date,
    data: Array,
    width: { default: 160, type: Number },
    height: { default: 80, type: Number },
  },

  data: function() {
    return {
      margin: 2,
      line_data: "",
      trendline_data: "",
    }
  },

  computed: {
    co2val() {
      return this.data.filter(
          d => d3.timeFormat("%Y-%m-%d")(d.date) == d3.timeFormat("%Y-%m-%d")(this.date - 1)
      )[0].value + " ppm"
    },

    display_data () {
      return this.data.filter(d => d.date <= this.date)
    },

    scale_x () {
      return  d3.scaleTime().range([0, this.width]).domain([0, this.display_data.length]);
    },

    scale_y () {
      return  d3.scaleLinear()
        .range([this.height - this.margin, this.margin])
        .domain(d3.extent(this.data , d => d.value))
    },

  },

  methods: {

    line () {
      var self = this;
      return  d3.line()
        .x(function(d,i) { return self.scale_x(i) })
        .y(function(d) {  return self.scale_y(d.value); })
    },

    trendline () {
      var self = this;
      return  d3.line()
        .x(function(d,i) { return self.scale_x(i) })
        .y(function(d) {  return self.scale_y(d.trend); })
    }
  },

  watch:  {
     date: function() {
        this.line_data = this.line()(this.display_data)
        this.trendline_data = this.trendline()(this.display_data)
    }
  },


}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#map {
  padding:0;margin:0;
  height: 100%;
  width: 100%;
}
svg { margin-top:10px}
#co2val {width:40%; margin:0px auto; opacity: 1;font-size:1em;}
</style>
